import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from './i18n'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: false
    },
    themes: {
      light: {

        primary: '#40c6a6', // color-brand-1 '#789D4A'
		    accent: '#6C9E3C', // color-brand-4
		    secondary: '#3EB1C8', // color-project-1
		    info: '#556677', // color-dark
        warning: '#EF426F',
		    error: '#F44336', // color-red
        success: '#6C9E3C', // color-green
        //'color-new-dark-green': '#6C9E3C',
        // 'color-new-title-green': '#A9C23F',
        'color-new-link-blue': '#485cc7', //'#4298B5',
        'color-new-body-grey': '#3D546C',
        'color-new-title-grey': '#6C829A',
        'color-new-dark-grey': '#435262',
        'color-new-light-grey': '#F7F8FA',
        'color-new-tab-grey': '#F0F1F5',
        'color-new-light-bluegrey': '#9aa5e0',
        'color-new-dark-orange': '#F1510B',
		    // 'color-brand-1': '#A9BF3C',
		    // 'color-brand-2': '#009688',
		    // 'color-brand-3': '#4298B5',
		    // 'color-brand-4': '#6C9E3C',
		    // 'color-brand-5': '#789C48', // Ugly genero background
		    // 'color-brand-6': '#A9BF3C', // genero footer color
		    'color-project-1': '#3EB1C8',
		    // 'color-project-2': '#3D546C',
		    // 'color-project-3': '#556677',
		    // 'color-project-4': '#F5F6FA',
		    // 'color-project-5': '#6E859D',
        // 'color-project-6': '#435262',
		    // 'color-project-7': '#cbdaea',
		    'color-white': '#fff',
		    // 'color-blue': '#3EB1C8', // colors.project.1
		    'color-green': '#6C9E3C', // color-brand-4
		    'color-red': '#F44336',
		    'color-orange': '#FF9600',
		    'color-grey': '#A2ADB8',
		    // 'color-light': '#f6f6f7',
		    // 'color-dark': '#556677',
        'custom-alert':'#1f2a44'
      },
    },
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  icons: {
    iconfont: 'fa',
  },
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1264,
      xl: 1424
    }
  }
});
